import { ConfirmationModal, type ConfirmationModalProps, Text } from '@shared/components';

type ProctorRequestSubmissionModalProps = Pick<
  ConfirmationModalProps,
  'open' | 'onClose' | 'onAccept' | 'onDiscard' | 'loading'
>;

export default function ProctorRequestSubmissionModal(
  props: Readonly<ProctorRequestSubmissionModalProps>,
) {
  const { open: isOpen, onClose, onAccept, onDiscard, loading } = props;

  return (
    <ConfirmationModal
      title='ยืนยันการส่งคำขออนุมัติ'
      content={
        <Text>
          เมื่อส่งคำขอแล้ว <strong>จะไม่สามารถแก้ไขข้อมูลได้อีก</strong>{' '}
          กรุณาตรวจสอบให้แน่ใจก่อนดำเนินการ?
        </Text>
      }
      acceptText='ส่งคำขออนุมัติ'
      discardText='ยกเลิก'
      open={isOpen}
      onClose={onClose}
      onAccept={onAccept}
      onDiscard={onDiscard}
      loading={loading}
    />
  );
}
